import { createApp } from 'vue' //vue本体
import App from './App.vue' //最初のコンポーネント読み込み
import router from './router'//ルーティング用
// import axios from 'axios'
// import './assets/styles/main.css'
// import './assets/reset.css';
import './assets/formreset.css';
import './assets/styles.css';

// セッションストレージ削除
// import "./static/preventload"

// font awesome 追加
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas)
library.add(far)


const app = createApp(App); //importしてるからVue.createAppとしなくてもいい
app.use(router);    //Vueインスタンス[app]とVue Routerインスタンスを結びつける

// fontawesomeの使用を登録
app.component('fa', FontAwesomeIcon )


app.mount('#app')   //Vueインスタンス[app]をDOMへ適用させる→App.vueのid=app部分がVueの管理下になる
